import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

export const chatHcpFullAccessPolicy = defineBuiltinPolicy({
  key: 'builtin:chat-hcp-full-access',
  name: 'Chat HCP Full Access',
  description: 'See every HCP in chat search and profiles, not only those assigned to the user.',
  actions: [PolicyActionEnum.ChatHcpViewAll],
});
